import React from 'react';
import { BaseBtnProps } from './types/BaseBtn.types';
import { Link, Text } from '@sitecore-jss/sitecore-jss-react';
import './BaseBtn.scss';

const BaseBtn = (props: BaseBtnProps) => {
  const {
    text,
    url,
    action = () => {},
    isRed,
    isFullwidth,
    className,
    icon,
    target = 'self',
    id,
    sitecoreProps,
    minWidth,
    customAttributes,
  } = props;
  let myClass = isRed ? 'BaseBtn BaseBtn--red' : 'BaseBtn';
  myClass += ' ga4-click-ui';
  if (className) {
    myClass += ` ${className}`;
  }
  if (isFullwidth) {
    myClass += ' BaseBtn--fullwidth';
  }
  const ButtonContent = () => (
    <>
      {(props.fields?.iconCssClass?.value || icon) && (
        <span
          className={`icon ${props.fields?.iconCssClass?.value || icon} mr-10`}
        />
      )}
      <Text field={props.fields?.label || { value: text?.value }}></Text>
    </>
  );

  return (
    <>
      {(props.fields?.link?.value?.href || url) && (
        <Link
          field={
            props.fields?.link || {
              value: {
                text: (
                  <>
                    {icon && <span className={`icon ${icon} mr-10`} />}
                    {text?.value}
                  </>
                ),
                target:
                  target === 'blank'
                    ? '_blank'
                    : target !== 'download'
                    ? '_self'
                    : '_self',
                href: url,
                id,
              },
              ...sitecoreProps,
            }
          }
          className={myClass}
          style={minWidth ? { minWidth: minWidth } : {}}
          onClick={action}
          rel="noopener noreferrer"
          download={target === 'download'}
          data-engine-info={customAttributes}
        >
          <ButtonContent />
        </Link>
      )}
      {!(props.fields?.link?.value?.href || url) && (
        <div className={myClass} onClick={action}>
          <ButtonContent />
        </div>
      )}
    </>
  );
};

export default BaseBtn;
